import React, {useState} from 'react';
import {Box, Button, FormControl, Typography} from '@mui/material';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {BUTTON_PRIMARY, NOT_OPENED, PENDING, SUCCESS} from '../assets/constants/Constants';
import {LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK, LS_LOCKER_BANK_INFO, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS} from '../assets/constants/BrowserStorageKeys';
import {DROP_PARCEL, LOCKER_UNIT_SELECTION, OPEN_LOCKER} from '../assets/constants/PageList';
import {getSecureItemFromSpecificStorage} from '../lib/BrowserStorageAccessMiddleware';
import {reserveLocker} from '../api/api';
import {getPathForNextPage, verifyUserProximity} from '../lib/Utils';
import ButtonComponent from '../components/ButtonComponent';
import CircularProgressLoader from '../components/CircularProgressLoader';
import CustomDialog from '../components/CustomDialog';

const LockerUnitSelectionPage = () => {
    const history = useHistory();
    const {t} = useTranslation();
    const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
    const tenantAndAssignmentSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
    const [isLoading, setIsLoading] = useState(false);
    const { lockerBankId, assignmentSlug, userId, selectedLockerSize,pickupUserDetails } = history.location?.state;
    const [selectedLockerUnit, setSelectedLockerUnit] = useState({id: null, door_no: ''});
    const [userProximityError, setUserProximityError] = useState('');
    const [isUserProximityErrorModalVisible, setIsUserProximityErrorModalVisible] = useState(false);
    const isParcelDropUser = tenantAndAssignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value;
    const lockerBank = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK);

    const reserveSelectedLocker = async () => {
        setIsLoading(true);
        try {
            if (tenantAndAssignmentSettings?.is_geofencing) {
                const lockerBankLatitude = lockerBankInfo?.latitude ? parseFloat(lockerBankInfo?.latitude) : null;
                const lockerBankLongitude = lockerBankInfo?.longitude ? parseFloat(lockerBankInfo?.longitude) : null;
                const maxAllowedDistanceInMeters = tenantAndAssignmentSettings?.geofencing_radius;
                const isUserNearbyLockerBank = await verifyUserProximity({latitude: lockerBankLatitude, longitude: lockerBankLongitude}, maxAllowedDistanceInMeters);

                if ( !isUserNearbyLockerBank.isNearby ) {
                    setIsLoading(false);
                    setUserProximityError(isUserNearbyLockerBank.message);
                    setIsUserProximityErrorModalVisible(true);
    
                    return;
                }
            }

            const reserveLockerResponse = await reserveLocker(assignmentSlug, lockerBankId, userId, selectedLockerSize.code, selectedLockerUnit.id);
            if (reserveLockerResponse.status === SUCCESS) {
                const isOpened = reserveLockerResponse?.data?.openstatus !== NOT_OPENED;
                const lockerUnitDetails = {
                    ref_id: reserveLockerResponse?.data?.transaction_id,
                    is_already_opened_once: false,
                    locker_bank: {
                        name: reserveLockerResponse?.data?.locker_bank_name
                    },
                    locker_door: {
                        door_no: reserveLockerResponse?.data?.door_no
                    }
                };

                if(isParcelDropUser){
                    let locker_bank_details = { lockerBank };  
                    locker_bank_details.location = {};  
                    locker_bank_details.location.name = reserveLockerResponse.data.locker_bank_location;
                    locker_bank_details.name = reserveLockerResponse.data.locker_bank_name;
                    history.push({
                    pathname: getPathForNextPage(LOCKER_UNIT_SELECTION , DROP_PARCEL),
                    state: {
                        locker_bank_details: locker_bank_details,
                        locker_unit_details: reserveLockerResponse.data,
                        pickupUserDetails: pickupUserDetails,
                        clientRef: reserveLockerResponse.data.client_ref || null,
                        hasPendingLockers: null,
                        isOpened: isOpened,
                        status: PENDING,
                        ref_id: reserveLockerResponse.data?.transaction_id,
                        open_locker_by_scan_barcode:false,
                        assignTime:reserveLockerResponse.data.assignment_timestamp,
                    }
                });
                }
                else{
                    history.replace({
                        pathname: getPathForNextPage(LOCKER_UNIT_SELECTION, OPEN_LOCKER),
                        state: {
                            lockerUnitDetails
                            // assignedLocker: response.data
                        }
                    });
                }
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Error while reserving locker: ', error);
        }
    };

    return (
        <Box className='locker-unit-selection-page'>
            <Box className='main-container'>
                {isLoading && (
                    <Box className='main'>
                        <CircularProgressLoader message={t('reservingLocker')} />
                    </Box>
                )}
                {(!isLoading) && (
                    <Box className='main'>
                        <Typography variant='h3' className='selected-locker-size'>{selectedLockerSize.name}</Typography>
                        <Box className='locker-unit-list'>
                            {selectedLockerSize?.free_doors.map((item, index) => (
                                <Button className={(selectedLockerUnit.id === item.id) ? 'locker-unit selected-unit': 'locker-unit'} key={index} disableRipple={true} onClick={() => setSelectedLockerUnit(item)}>{t('Locker_text')} - {item.door_no}</Button>
                            ))}
                        </Box>
                        <Box className='reserve-locker-button-container'>
                            <ButtonComponent buttonId='reserve-locker' title={selectedLockerUnit.id === null ? t('reserveLockerText') : `${t('reserveLockerText')} - ${selectedLockerUnit.door_no}`} disabled={selectedLockerUnit.id === null} handleClick={reserveSelectedLocker} />
                        </Box>
                    </Box>
                )}
                <CustomDialog
                    dialogId='user-proximity-error-modal'
                    dialogVisible={isUserProximityErrorModalVisible}
                    onClose={() => setIsUserProximityErrorModalVisible(false)}
                    handleCancel={() => setIsUserProximityErrorModalVisible(false)}
                    dialogTitle={t('Location_error')}
                    dialogContentText={userProximityError}
                    buttonOneTitle={t('button_ok')}
                    buttonProps={{buttonOne: {type: BUTTON_PRIMARY}}}
                />
            </Box>
        </Box>
    );
};

export default LockerUnitSelectionPage;